module.exports = __webpack_public_path__ + "static/media/NeedsList.dd14bd5a.csv";